import type { SiteConfig } from '../../@types/context/site-config.types';

export const organisationZmartaNoConfig: Pick<SiteConfig, 'organisation'> = {
  organisation: {
    name: 'Zmarta AS',
    number: '985 220 239',
  },
};
